import { render, staticRenderFns } from "./footermenu.vue?vue&type=template&id=7a60b28a&scoped=true&"
import script from "./footermenu.vue?vue&type=script&lang=ts&"
export * from "./footermenu.vue?vue&type=script&lang=ts&"
import style0 from "./footermenu.vue?vue&type=style&index=0&id=7a60b28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a60b28a",
  null
  
)

export default component.exports